/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleItemsControllerStreamContentQueryResponse, TrimbleItemsControllerStreamContentQueryParams } from "../../models/trimbleController/TrimbleItemsControllerStreamContent";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trimbleItemsControllerStreamContent } from "../../clients/trimbleService/trimbleItemsControllerStreamContent";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trimbleItemsControllerStreamContentQueryKey = (params: TrimbleItemsControllerStreamContentQueryParams) => [{
  url: '/api/v1/trimble/content'
}, ...(params ? [params] : [])] as const;
export type TrimbleItemsControllerStreamContentQueryKey = ReturnType<typeof trimbleItemsControllerStreamContentQueryKey>;
export function trimbleItemsControllerStreamContentQueryOptions(params: TrimbleItemsControllerStreamContentQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trimbleItemsControllerStreamContentQueryKey(params);
  return queryOptions<TrimbleItemsControllerStreamContentQueryResponse, ResponseErrorConfig<Error>, TrimbleItemsControllerStreamContentQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trimbleItemsControllerStreamContent(params, config);
    }
  });
}

/**
 * @summary Stream the bytes of a Trimble file
 * {@link /api/v1/trimble/content}
 */
export function useTrimbleItemsControllerStreamContent<TData = TrimbleItemsControllerStreamContentQueryResponse, TQueryData = TrimbleItemsControllerStreamContentQueryResponse, TQueryKey extends QueryKey = TrimbleItemsControllerStreamContentQueryKey>(params: TrimbleItemsControllerStreamContentQueryParams, options: {
  query?: Partial<QueryObserverOptions<TrimbleItemsControllerStreamContentQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trimbleItemsControllerStreamContentQueryKey(params);
  const query = useQuery({
    ...trimbleItemsControllerStreamContentQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}